export default "__VITE_ASSET__eVdoCWCwuvNpyew3U9aj$w__"